import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.mjs';
import A11y from 'swiper/modules/a11y.mjs';

let keyboardNavigation = false;
document.addEventListener('keydown', (e) => {
    if (['Space', 'Enter'].includes(e.code)) {
        keyboardNavigation = true;
    }
});

function customSwiper() {
    document.addEventListener('DOMContentLoaded', () => {
        const swiper = new Swiper('#swiperHero', {
            modules: [Navigation, Pagination, A11y],
            direction: 'horizontal',
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            a11y: {
                enabled: true,
                containerMessage: 'Dies ist ein Slider',
                containerRole: 'region',
                containerRoleDescriptionMessage: 'Ein slider mit mehreren Themen',
                firstSlideMessage: 'Dies ist die erste Folie',
                lastSlideMessage: 'Dies ist die letzte Folie',
                nextSlideMessage: 'Nächste Folie',
                prevSlideMessage: 'Vorherige Folie',
                slideLabelMessage: 'Folie {{index}} von {{slidesLength}}',
                itemRoleDescriptionMessage: 'Einzelelement des Karussells',
                slideRole: 'group',
                scrollOnFocus: true,
                notificationClass: 'swiper-notification'
            },
            on: {

                init() {
                    // updateSlideHeight(this);
                    setSlideTabbing(this);
                    makeNavigationAccessible();
                },
                slideChange() {
                    // updateSlideHeight(this);
                    setSlideTabbing(this);
                },
                slideChangeTransitionEnd() {

                    // Aktives Slide holen
                    const activeSlide = document.querySelector('.swiper-slide-active');
                    if (!activeSlide) {
                        keyboardNavigation = false;
                        return;
                    }

                    // inert entfernen und erst dann Fokus setzen
                    if (activeSlide.hasAttribute('inert')) {
                        activeSlide.removeAttribute('inert');
                    }

                    const heading = activeSlide.querySelector('h2');
                    if (!heading) {
                        keyboardNavigation = false;
                        return;
                    }

                    heading.setAttribute('tabindex', '-1');
                    heading.focus();

                    // tabindex nach kurzer Verzögerung entfernen, wenn Fokus bleibt
                    setTimeout(() => {
                        if (document.activeElement === heading) {
                            heading.removeAttribute('tabindex');
                        } else {
                        }
                        keyboardNavigation = false;
                    }, 200);
                },
            },
        });

        function updateSlideHeight(swiperInstance) {        
            if (window.innerWidth >= 992) {
                swiperInstance.slides.forEach(slide => slide.style.height = '');
                return;
            }

            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
            const textElement = activeSlide.querySelector('.swiper-text');

            if (textElement) {
                const height = textElement.offsetHeight + 200;
                swiperInstance.slides.forEach(slide => slide.style.height = '');
                activeSlide.style.height = `${height}px`;
            }
        }

        function setSlideTabbing(swiperInstance) {
            swiperInstance.slides.forEach(slide => {
                if (slide.classList.contains('swiper-slide-active')) {
                    slide.removeAttribute('inert');
                    slide.querySelectorAll('h2').forEach(el => el.setAttribute('tabindex', '0'));
                } else {
                    slide.setAttribute('inert', '');
                    slide.querySelectorAll('h2').forEach(el => el.setAttribute('tabindex', '-1'));
                }
            });
        }

        function makeNavigationAccessible() {
            document.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(button => {
                button.addEventListener('keydown', function (event) {
                    if (event.code === 'Enter' || event.code === 'Space') {
                        event.preventDefault();
                        button.click();
                    }
                });
            });
        }

        // window.addEventListener('resize', () => updateSlideHeight(swiper));
    });
}

function indexNavigation(){
    const indexNavObject = document.getElementById('indexNav');

    if(indexNavObject){

        const indexNavSwiper = new Swiper(indexNavObject, {
            modules: [Navigation, A11y],
            slidesPerView: 'auto',
            direction: 'horizontal',
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                nextEl: '.swiper-index-button-next',
                prevEl: '.swiper-index-button-prev',
            },
            a11y: {
                enabled: true,
                containerRole: '',
                slideRole: '',
            },
        });

        // MutationObserver: aktivem Slide an den Anfang scrollen
        const navLinks = document.querySelectorAll('#indexNav .nav-link');

        const observer = new MutationObserver(() => {
            const activeLink = document.querySelector('#indexNav .nav-link.active');
            if (activeLink) {
                const activeSlide = activeLink.closest('.swiper-slide');
                const slideIndex = Array.from(activeSlide.parentNode.children).indexOf(activeSlide);
                indexNavSwiper.slideTo(slideIndex, 300);
            }
        });

        navLinks.forEach(link => {
            observer.observe(link, { attributes: true, attributeFilter: ['class'] });
        });

    }
}

export default customSwiper;
export { indexNavigation };
